import { render } from "./footer-comp.vue?vue&type=template&id=0e14f290&scoped=true"
import script from "./footer-comp.vue?vue&type=script&lang=js"
export * from "./footer-comp.vue?vue&type=script&lang=js"

import "./footer-comp.vue?vue&type=style&index=0&id=0e14f290&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3414373455/src/platform-insurance-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e14f290"]])

export default __exports__